module.exports = __webpack_public_path__ + "media/images/icon__community@3x-925558a47390166d7dc0e0cfb7fda9e2.png";